import React, { useEffect, useState } from "react";
import { Table, Pagination, Select, Input, Checkbox, Button } from "antd";
import { getRequest } from "../../util/APIUtils";
import { CaretDownOutlined,RightOutlined } from "@ant-design/icons";
import "../Modal/AllUserTableModal.css";

const PAGE_SIZES = [5, 10, 20, 50, 100];

const UserList = () => {
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [dataSource, setDataSource] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZES[0]);
  const [goToPage, setGoToPage] = useState("");
  const [selectedFilters, setSelectedFilters] = useState([]);

  useEffect(() => {
    fetchData();
  }, [currentPage, pageSize, selectedFilters]);

const fetchData = () => {
    getRequest("/form/getPetrolOfisi")
      .then((response) => {
        const sortedData = response.data.sort((a, b) => b.recordId - a.recordId);

        const filteredData = sortedData.filter((user) => {
          if (selectedFilters.length === 0) {
            return true;
          }
          return selectedFilters.includes(user.invoiced.toString());
        });


        setTotalDataCount(filteredData.length);

        setDataSource(
          filteredData.slice(
            (currentPage - 1) * pageSize,
            currentPage * pageSize
          )
        );
      })
      .catch((error) => {
        console.error("Veri çekme hatası:", error);
      });
  };


  const handleFilterChange = (values) => {
    setSelectedFilters(values);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
    const startIndex = 0;
    const endIndex = startIndex + value;
  };

  const handleGoToPageChange = (event) => {
    const { value } = event.target;
    if (/^\d*$/.test(value)) {
      setGoToPage(value);
    }
  };

  const handleGoToPageEnter = (event) => {
    if (event.key === "Enter") {
      const pageNumber = parseInt(goToPage);
      if (
        !isNaN(pageNumber) &&
        pageNumber >= 1 &&
        pageNumber <= Math.ceil(totalDataCount / pageSize)
      ) {
        setCurrentPage(pageNumber);
      }
    }
  };

const clearFilters = () => {
  setSelectedFilters([]);
  setCurrentPage(1);
  fetchData();
};


  const columns = [
    {
      title: "Record",
      dataIndex: "recordId",
      key: "recordId",
      className: "hidden",


    },
    {
      title: "Yeni Dokuman Adi",
      dataIndex: "newDocumentId",
      key: "newDocumentId",
    },
    {
          title: "Faturalandirma",
          dataIndex: "invoiced",
          key: "invoiced",
          filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <div style={{ padding: 8 }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex" }}>
                  <div style={{ marginRight: "8px" }}>
                  <RightOutlined />
                    <Checkbox
                      value="0"
                      onChange={(e) =>
                        handleFilterChange(
                          e.target.checked
                            ? selectedFilters.concat(["0"])
                            : selectedFilters.filter((filter) => filter !== "0")
                        )
                      }
                      checked={selectedFilters.includes("0")}
                    >
                      Bekleyen
                    </Checkbox>
                  </div>
                  <div>
                  <RightOutlined />
                    <Checkbox
                      value="2"
                      onChange={(e) =>
                        handleFilterChange(
                          e.target.checked
                            ? selectedFilters.concat(["2"])
                            : selectedFilters.filter((filter) => filter !== "2")
                        )
                      }
                      checked={selectedFilters.includes("2")}
                    >

                      Başarılı
                    </Checkbox>
                  </div>
                </div>
                <div>
                <RightOutlined />
                  <Checkbox
                    value="44"
                    onChange={(e) =>
                      handleFilterChange(
                        e.target.checked
                          ? selectedFilters.concat(["44"])
                          : selectedFilters.filter((filter) => filter !== "44")
                      )
                    }
                    checked={selectedFilters.includes("44")}
                  >
                    Başarısız
                  </Checkbox>
                </div>
              </div>

            </div>
          ),
          filterIcon: (filtered) => (
            <CaretDownOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
          ),
        },
    {
      title: "Faturalandirma Tarihi ",
      dataIndex: "invoiced_at",
      key: "invoiced_at",
    },
    {
      title: "Filo Numarasi",
      dataIndex: "floNumber",
      key: "floNumber",
    },
    {
      title: "Odenecek Miktar",
      dataIndex: "payableAmount",
      key: "payableAmount",
    },
    {
      title: "Olusturulma tarihi",
      dataIndex: "createdAt",
      key: "createdAt",
    },
  ];


  return (
    <div className="page">
      <div className="tableAll">
        <Table dataSource={dataSource} columns={columns} pagination={false} />
      </div>

      <div className="footer">
        <div className="toplam">Toplam {totalDataCount} Kayıt</div>

        <div className="pagination-container">
          <Pagination
            current={currentPage}
            total={totalDataCount}
            pageSize={pageSize}
            onChange={handlePageChange}
          />
        </div>

        <div className="sayfa">
          <Select value={pageSize} onChange={handlePageSizeChange}>
            {PAGE_SIZES.map((size) => (
              <Select.Option key={size} value={size}>
                {size} /{" "}
                <span style={{ minWidth: "3ch", display: "inline-block" }}>
                  sayfa
                </span>
              </Select.Option>
            ))}
          </Select>
        </div>

        <div className="git">
          <label style={{ minWidth: "3ch" }}>Git </label>
          <Input
            style={{ width: "7ch", height: "31px" }}
            value={goToPage}
            onChange={handleGoToPageChange}
            onKeyPress={handleGoToPageEnter}
          />
          <span style={{ display: "inline-block", minWidth: "5ch" }}>
            {" "}
            Sayfa
          </span>
        </div>
      </div>
    </div>
  );
};

export default UserList;



// WEBPACK FOOTER //
// ./src/component/Table/UserList.js